import { Component } from "@angular/core";

@Component({
  selector: "standalone-sidebar-footer",
  template: " <ng-content></ng-content>",
  styleUrls: ["./standalone-sidebar-footer.component.scss"],
})
export class StandaloneSidebarFooterComponent {}
